var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVessel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#ffd600",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.7173 13.87 1.6954-5.0014c0.23852-0.70361 0.83411-1.2267 1.5626-1.3724l0.9642-0.19285c2.0204-0.40408 4.1008-0.40408 6.1212 0l0.9643 0.19285c0.7285 0.1457 1.3241 0.66877 1.5626 1.3724l1.6954 5.0014",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.6766 19.175-1.0404-4.1616 9.3637-3.1212 9.3637 3.1212-1.0405 4.1616",
    strokeLinecap: "square",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3 22c2.1176 0 1.9059-2 3.8824-2 2.4706 0 2.1176 2 3.8824 2s2.1177-2 4.2353-2 2.1176 2 4.2353 2c2.1176 0 1.7647-2 3.8823-2 2.1177 0 1.7648 2 3.8824 2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVessel);
export default __webpack_public_path__ + "static/media/vessel.f2a907f74ff766ffb3c1ef7830ada215.svg";
export { ForwardRef as ReactComponent };